if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// COLOR FILTER - FINAL WORKING CODE
(function () {
  function getVariants() {
    try {
      return (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        window.ShopifyAnalytics.meta.product.variants
      ) || [];
    } catch (e) { return []; }
  }

  function findMediaIdByColor(colorTitle) {
    var variants = getVariants();
    var colorLower = colorTitle.toLowerCase().trim();

    // Us color ka pehla variant jo featured_image rakhta ho
    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 && v.option1.toLowerCase().trim() === colorLower && v.featured_image) {
        matched = v;
        break;
      }
    }
    if (!matched) return null;

    var featFile = matched.featured_image.src.split('?')[0].split('/').pop();

    // Gallery thumbnails mein se data-target dhundo
    var thumbItems = document.querySelectorAll('[data-target]');
    var foundTarget = null;

    thumbItems.forEach(function (item) {
      if (foundTarget) return;
      var btn = item.querySelector('button, [aria-label]');
      var img = item.querySelector('img');
      if (!img) return;
      var imgFile = img.src.split('?')[0].split('/').pop();
      if (imgFile === featFile) {
        foundTarget = item.dataset.target;
      }
    });

    // Agar thumbnail se nahi mila to main slides check karo
    if (!foundTarget) {
      var slides = document.querySelectorAll('[data-media-id]');
      slides.forEach(function (slide) {
        if (foundTarget) return;
        var img = slide.querySelector('img');
        if (!img) return;
        var imgFile = img.src.split('?')[0].split('/').pop();
        if (imgFile === featFile) {
          foundTarget = slide.dataset.mediaId;
        }
      });
    }

    return foundTarget;
  }

  function activateColorMedia(colorTitle) {
    var mediaId = findMediaIdByColor(colorTitle);
    if (!mediaId) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    // setActiveMedia(mediaId, prepend=true) - prepend=true thumbnail ko pehle le aata hai
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, true);
    }
  }

  // Swatch click listener
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.main-image-swatch');
    if (!swatch) return;
    var colorTitle = swatch.getAttribute('title');
    if (!colorTitle) return;
    // Thoda wait karo taaki variant change ho sake
    setTimeout(function () {
      activateColorMedia(colorTitle);
    }, 150);
  });

})();
